// extracted by mini-css-extract-plugin
module.exports = {"navigation":"index-module--navigation--3K8Gc","icon":"index-module--icon--foHm6"};